import React from 'react';
import {PropTypes} from 'prop-types';

import copy from "../copy";
import {Input} from "../../components/input";
import {validateSingleLine} from "../../utils/validation";

/**
 * Reusable component for rendering employer name form field
 *
 * @param {string}                 value - input value
 * @param {boolean|string}         error - whether or not the input should show the error view. When string, contains the error message
 * @param {function}               onChange - onChange event handler
 * @param {string}                 controlId - input control id
 */
export function EmployerNameField(props) {
    return (
        <Input
            {...copy.employer_name}
            autoValidateAndFormat
            validator={validateSingleLine}
            required
            onBlur={props.onChange}
            {...props}
        />
    );
}

EmployerNameField.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string]),
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    controlId: PropTypes.string, 
};
